import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Hidden,
} from '@material-ui/core'

import BloksOutlineImage from '../../../assets/images/hero_graphic_solution.svg'
import HeroImage from '../../../assets/images/solutionsedmonds.jpg'

import LearnMoreCard from './LearnMoreCard'
import Footer from './Footer'
import TopNav from './TopNav'

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    root: {
      minHeight: '100vh',
    },
    contentColumn: {
      backgroundColor: '#FFD850',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${BloksOutlineImage})`,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
    },
    communityHero: {
      backgroundColor: '#333',
      backgroundImage: `url(${HeroImage})`,
    },
    contentColumnContainer: {
      minHeight: '100%',
      flexWrap: 'nowrap',
    },
    promptContainer: {
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(2, 0),
      },
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(3, 0),
      },
      flexGrow: 1,
    },
  })

  render() {
    const { children, classes } = this.props

    return (
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={12} md={6} className={classes.contentColumn}>
          <Grid container direction="column" justify="center" className={classes.contentColumnContainer}>
            <Grid item>
              <TopNav />
            </Grid>
            <Grid item container className={classes.promptContainer} direction="column" justify="center" alignItems="center">
              { children }
            </Grid>
            <Grid item>
              <Footer />
            </Grid>
          </Grid>
        </Grid>
        <Hidden smDown>
          <Grid item md={6} className={`${classes.contentColumn} ${classes.communityHero}`}>
            <Grid container justify="center" alignItems="flex-end" className={classes.contentColumnContainer}>
              <Grid item>
                <LearnMoreCard />
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    )
  }
}

export default withStyles(Layout.styles)(Layout)
